module.exports = __webpack_public_path__ + "img/aqs_img_01.31eafcc8.jpg";